var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCommandSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zM7.8 18c-.99 0-1.8-.81-1.8-1.8s.81-1.8 1.8-1.8h.8c.55 0 1 .45 1 1v.8c0 .99-.81 1.8-1.8 1.8zm.8-8.4h-.8C6.81 9.6 6 8.79 6 7.8S6.81 6 7.8 6s1.8.81 1.8 1.8v.8c0 .55-.45 1-1 1zm4.65 4.55h-2.51c-.49 0-.9-.4-.9-.9v-2.51c0-.49.4-.9.9-.9h2.51c.49 0 .9.4.9.9v2.51c0 .49-.4.9-.9.9zm1.15 2.05v-.8c0-.55.45-1 1-1h.8c.99 0 1.8.81 1.8 1.8s-.81 1.8-1.8 1.8-1.8-.81-1.8-1.8zm1-6.6c-.55 0-1-.45-1-1v-.8c0-.99.81-1.8 1.8-1.8s1.8.81 1.8 1.8-.81 1.8-1.8 1.8h-.8z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCommandSquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-command-square.5b56d03d6163eeab0d93c6c60a504487.svg";
export { ForwardRef as ReactComponent };